module.exports = __webpack_public_path__ + "img/ferienhaus_debontje_greetsiel_schlafzimmer_oben_gross_01.07be559c.jpg";